import React, { useEffect, useRef, useState } from 'react'
import { CloudDownloadOutlined, UploadOutlined, FileOutlined, VerticalAlignBottomOutlined } from '@ant-design/icons';
import { Col, Drawer, Popconfirm, Row } from 'antd';
import { Button, message, Upload } from 'antd';
import { PopInputArea } from './PopInputArea';
import { Info, Lyric, create_from_LRC } from '../../../../utils/lyric';
import { Howl } from 'howler'
import "./DataIO.css"
import { RcFile } from 'antd/es/upload';

import intl from 'react-intl-universal'
import { createWaveformData, WaveformData } from '../../../../utils/audio';


type DataIOProps = {
    lyc: Lyric
    setLyc: React.Dispatch<React.SetStateAction<Lyric>>
    song: Howl | undefined
    replaceSong: (song: Howl, objectUrl: string) => void
    setWaveform: React.Dispatch<React.SetStateAction<WaveformData | undefined>>
    loadsongicon: boolean
    setLoadsongicon: React.Dispatch<React.SetStateAction<boolean>>
}

export default function DataIO(props: DataIOProps) {

    const [drawopen,setDrawopen]=useState<boolean>(false)
    const [uploadedFileName, setUploadedFileName] = useState<string>("")

    const uploadTokenRef = useRef(0)
    const pendingAudioRef = useRef<{ song: Howl, url: string }>()

    useEffect(() => () => {
        uploadTokenRef.current += 1
        pendingAudioRef.current?.song.unload()
        if (pendingAudioRef.current) URL.revokeObjectURL(pendingAudioRef.current.url)
    }, [])

    function uploadlyric(file: RcFile) {
        const reader = new FileReader();
        reader.addEventListener('load', () => {
            const mylrc = create_from_LRC(reader.result + "")
            props.setLyc(mylrc)
        });
        reader.readAsText(file)
        return false
    }

    function uploadmusic(file: RcFile) {
        const uploadToken = uploadTokenRef.current + 1
        uploadTokenRef.current = uploadToken
        pendingAudioRef.current?.song.unload()
        if (pendingAudioRef.current) URL.revokeObjectURL(pendingAudioRef.current.url)
        pendingAudioRef.current = undefined

        const lastDot = file.name.lastIndexOf('.')
        setUploadedFileName(lastDot > 0 ? file.name.slice(0, lastDot) : file.name)

        props.setLoadsongicon(true)
        props.setWaveform(undefined)

        const objectUrl = URL.createObjectURL(file)
        const extension = file.name.includes('.') ? file.name.split('.').pop()?.toLowerCase() : undefined
        const song = new Howl({
            src: [objectUrl],
            format: extension ? [extension] : undefined,
            html5: true,
            preload: true,
            volume: 0.3
        })
        pendingAudioRef.current = { song, url: objectUrl }
        let audioLoaded = false
        let analyzedWaveform: WaveformData | undefined

        song.once('load', () => {
            if (uploadToken !== uploadTokenRef.current) return
            audioLoaded = true
            pendingAudioRef.current = undefined
            props.replaceSong(song, objectUrl)
            if (analyzedWaveform) props.setWaveform(analyzedWaveform)
            props.setLoadsongicon(false)
        })
        song.once('loaderror', (_id, error) => {
            if (uploadToken !== uploadTokenRef.current) return
            uploadTokenRef.current += 1
            pendingAudioRef.current = undefined
            URL.revokeObjectURL(objectUrl)
            props.setLoadsongicon(false)
            message.error(`${intl.get('music-load-error')}: ${String(error)}`)
        })

        createWaveformData(file)
            .then(data => {
                analyzedWaveform = data
                if (audioLoaded && uploadToken === uploadTokenRef.current) props.setWaveform(data)
            })
            .catch(() => {
                if (uploadToken === uploadTokenRef.current) message.warning(intl.get('waveform-unavailable'))
            })
        return false
    }

    const createNewLyc = () => {

        const newlyc = new Lyric(false)
        newlyc.addblank_sentence(-1, 0)
        newlyc.addinfo(-1, new Info("", ""))
        props.setLyc(newlyc)

    }

    const downloadLyc = (twin:boolean) => {
        let stringData;
        if (twin === false){
            // 要保存的字符串
            stringData = props.lyc.toLyc()
        }else{
            stringData = props.lyc.toTwinLyc()
        }
        // dada 表示要转换的字符串数据，type 表示要转换的数据格式
        const blob = new Blob([stringData], {
            type: "text/plain;charset=utf-8"
        })
        // 根据 blob生成 url链接
        const objectURL = URL.createObjectURL(blob)

        // 创建一个 a 标签Tag
        const aTag = document.createElement('a')
        // 设置文件的下载地址
        aTag.href = objectURL
        // 设置保存后的文件名称
        aTag.download = (uploadedFileName || "yourlrc") + ".lrc"
        // 给 a 标签添加点击事件
        aTag.click()
        // 释放一个之前已经存在的、通过调用 URL.createObjectURL() 创建的 URL 对象。
        // 当你结束使用某个 URL 对象之后，应该通过调用这个方法来让浏览器知道不用在内存中继续保留对这个文件的引用了。
        URL.revokeObjectURL(objectURL)

    }

    return (<div id="DataIOArea">
        <Col>
            <Row justify={'start'}>
                <Upload fileList={[]} accept="audio/*,.mp3,.wav,.m4a,.aac,.ogg,.flac,.opus" beforeUpload={uploadmusic}>
                    <Button style={props?.song ? {} : { 'color': 'green' }} icon={<UploadOutlined />}>{intl.get("upload-music")}</Button>
                </Upload>
            </Row>
            {/* 文字超过10个自动缩略 */}
            <div style={{ 'height': '24px', 'width': '8em', 'overflow': 'hidden', 'textOverflow': 'ellipsis','whiteSpace': 'nowrap'}}>{uploadedFileName}</div>
            <Row justify={'start'} className="data-button-group">
                <Upload fileList={[]} accept='.lrc' beforeUpload={uploadlyric}>
                    <Button style={props?.lyc.senlist.length === 0 ? { 'color': 'green' } : {}} icon={<UploadOutlined />}>{intl.get("upload-lyric")}</Button>
                </Upload>
                <div className="secondary-buttons">
                    <Button icon={<CloudDownloadOutlined />} onClick={()=>setDrawopen(true)}>{intl.get("upload-sens")}</Button>
                    <Button icon={<CloudDownloadOutlined />} onClick={() => { window.open("https://music.liuzhijin.cn/") }}>{intl.get("find-lyric")}</Button>
                </div>

            </Row>
            <div style={{ 'height': '4px' }}></div>
            <Row>
                <Popconfirm
                    title={intl.get("create-lyric")}
                    description={intl.get("create-new-warn")}
                    onCancel={createNewLyc}
                    okText={intl.get("no")}
                    cancelText={intl.get("yes")}
                    placement="topLeft"
                >
                    <Button icon={<FileOutlined />} style={props?.lyc.senlist.length === 0 ? { 'color': 'green' } : {}}>{intl.get("create-lyric")}</Button>
                </Popconfirm>
            </Row>
            <div style={{ 'height': '24px' }}></div>
            <Row justify={'start'} className="data-button-group">
                <Button icon={<VerticalAlignBottomOutlined />} onClick={()=>downloadLyc(false)}>{intl.get("download-lyric")}</Button>
                <div className="secondary-buttons">
                    <Button icon={<VerticalAlignBottomOutlined />} onClick={()=>downloadLyc(true)}>{intl.get("download-lyric-twin")}</Button>
                </div>
            </Row>
        </Col>
        <Drawer 
        title={intl.get("upload-sens")}
        onClose={()=>setDrawopen(false)}
        open={drawopen}
        placement="left"
        >
            <PopInputArea drawopen={drawopen} setLyc={props.setLyc}/>
        </Drawer>

    </div>)
}
